// extracted by mini-css-extract-plugin
export default {"container":"pills-menu_container__13Jkj","item":"pills-menu_item__3EwQ_","label":"pills-menu_label__2n4hw"};